/**
 * Web cookie / local-storage preference consent (PDPL transparency).
 * Separate from clinical PDPL consent (/consent) — this only covers browser storage
 * categories used by the web app (necessary auth/session vs optional analytics).
 */

const STORAGE_KEY = "vitra_cookie_consent_v1";
export const COOKIE_CONSENT_VERSION = "1";

export const COOKIE_CATEGORIES = {
  necessary: true,
  analytics: false,
};

export function readCookieConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== COOKIE_CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasCookieConsentDecision() {
  return !!readCookieConsent();
}

export function canUseAnalytics() {
  const c = readCookieConsent();
  return !!(c && c.analytics === true);
}

export function saveCookieConsent({ analytics = false } = {}) {
  const payload = {
    version: COOKIE_CONSENT_VERSION,
    necessary: true,
    analytics: !!analytics,
    acceptedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  try {
    window.dispatchEvent(new CustomEvent("vitra-cookie-consent", { detail: payload }));
  } catch {
    /* ignore */
  }
  return payload;
}

export function clearCookieConsent() {
  localStorage.removeItem(STORAGE_KEY);
}
